var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIraIconColoured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22557_14595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2141 34.5013C17.6841 34.5013 17.2557 34.0729 17.2557 33.543V25.1576C17.2557 24.6276 17.6841 24.1992 18.2141 24.1992C18.744 24.1992 19.1724 24.6276 19.1724 25.1576V33.543C19.1724 34.0729 18.744 34.5013 18.2141 34.5013Z",
    fill: "#FFDA84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9641 17.25C22.379 17.25 21.0891 15.9601 21.0891 14.375C21.0891 12.7899 22.379 11.5 23.9641 11.5C25.5492 11.5 26.8391 12.7899 26.8391 14.375C26.8391 15.9601 25.5492 17.25 23.9641 17.25Z",
    fill: "#FFDA84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1458 34.4987H23.9583C23.4293 34.4987 23 34.0694 23 33.5404V23.7174L21.1255 25.1272C20.7479 25.4635 20.286 25.6782 19.7867 25.7501L18.3051 25.9647C17.802 26.0385 17.2893 25.8871 16.9041 25.5527C16.5169 25.2163 16.2946 24.7294 16.2946 24.2148C16.2946 23.543 16.6664 22.9374 17.2644 22.6364L19.9324 21.29C20.1078 21.2018 20.2563 21.0696 20.3646 20.9057L20.8495 20.1735C21.6622 18.9459 23.0374 18.207 24.5103 18.207H25.5827C26.2488 18.207 26.8765 18.4552 27.347 18.9057C28.8861 20.3729 29.6374 22.8569 29.7103 26.7228C29.7304 27.8057 29.4208 28.8608 28.8142 29.777L28.5181 30.2236C28.0916 30.8676 27.8636 31.6227 27.8636 32.3952V33.7809C27.8645 34.1767 27.5425 34.4987 27.1458 34.4987Z",
    fill: "#FFDA84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22557_14595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraIconColoured);
export default __webpack_public_path__ + "static/media/ira_icon_coloured.f2770985b989d81aa44937afd246c063.svg";
export { ForwardRef as ReactComponent };